<template>
  <div>
    <div class="p-2 bg-white border-2 border-b-0 rounded-t gap-2 flex items-center justify-between">
      <div>
        <v-btn @click="toggleSelectAll" elevation="0" class="mr-2">{{ $t('select_all') }}</v-btn>
        <v-btn
          class="mr-2"
          @click="isConfirm  = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="primary"
        >{{ $t('task.approve_count', { count: selected.length }) }}</v-btn>
        <v-btn
          class="mr-2"
          @click="isCancel  = true"
          :disabled="selected.length < 1"
          elevation="0"
          color="error"
        >{{ $t('task.not_approve_count', { count: selected.length }) }}</v-btn>
      </div>
      <div>
        <v-btn icon elevation="0" color="primary" @click="onInit()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
    </div>
    <template>
      <v-data-table
        show-select
        :headers="headers"
        :items="renewContractDataTable"
        :loading="loading || isLoading"
        :items-per-page="50"
        class="border-2"
        v-model="selected"
        @toggle-select-all="toggleSelectAll"
        item-key="objectId"
        :no-data-text="$t('contract.no_renew_contract')"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:item.stallType="{ item }">
          {{ item.stallType ? $t(`contact.stall_type.${item.stallType}`) : '-' }}
        </template>
        <template v-slot:item.startDate="{ item }">
          {{ $moment(item.startDate).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:item.endDate="{ item }">
          {{ $moment(item.endDate).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:item.paidStatus="{ item }">
          <v-chip :class="item.contract.status.color" @click="openContractDialog(item.contract)">{{ item.contract.status.text }}</v-chip>
        </template>
        <template v-slot:item.ageExpireStatus="{ item }">
          <v-chip v-if="item.ageExpireStatus" :color="item.ageExpireStatus.color">{{ item.ageExpireStatus.text }}</v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
            {{ item.statusString }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickEdit(item)"
            >{{ $t('detail') }}</v-btn>
          </div>
        </template>

        <!-- <template v-slot:item.areas="{ item }">
          <template v-if="item.contractCheckOut.areas && item.contractCheckOut.areas.length">{{ item.contractCheckOut.areas.map(d => d.name).join(',') }}</template>
        </template>
        <template v-slot:item.leaveDate="{ item }">
          <template v-if="item.contractCheckOut.checkOutDate">
            {{ $moment(item.contractCheckOut.checkOutDate).format('DD-MM-YYYY') }}
          </template>
        </template>
        <template v-slot:item.status="{ item }">
          <span :class="item.statusColor + ' px-3 py-1 rounded-full '">
            {{ item.statusString }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="flex justify-end">
            <v-btn
              color="grey lighten-4"
              elevation="0"
              rounded
              small
              @click="onClickEdit(item)"
            >รายละเอียด</v-btn>
          </div>
        </template> -->
      </v-data-table>
    </template>
    <template>
      <approve
        v-if="isApprove"
        v-model="isApprove"
        :marketId="marketId"
        :projectId="projectId"
        :approveId="approveTask.objectId"
        :renewContractId="approveTask.renewContract.objectId"
        :isUpdate="true"
        @onApproveTaskEvent="onInit"
        @onEditContractCheckOut="editContractCheckOut"
      ></approve>
    </template>
    <v-dialog v-model="isConfirm" persistent max-width="400">
      <v-card>
        <v-card-text class="py-5 success--text">
          <h4>{{ $t('task.want_approve') }} <b>{{selected.length}}</b> {{ $t('task.question_approve_list') }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="isConfirm = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" @click="approveConfirm" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isCancel" persistent max-width="400">
      <v-card>
        <v-card-text class="py-5 error--text">
          <h4>{{ $t('task.want_not_approve') }} <b>{{selected.length}}</b> {{ $t('task.question_approve_list') }}</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="isCancel = false">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" @click="rejectConfirm" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ContractDetailDialog 
      v-model="isContractDialog" 
      :contractId="tempContract ? tempContract.objectId : null" 
      :show-area="true" 
      :projectId="projectId"
      :marketId="marketId" 
      initTab="Bill"/>
  </div>
</template>


<script>
import Approve from "./Approve.vue";
import ContractDetailDialog from "./ContractDetailDialog.vue";
export default {
  components: { Approve, ContractDetailDialog },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      isInterest: false,
      interestId: null,
      approveId: null,
      isConfirm: false,
      isCancel: false,
      isApprove: false,
      approveTask: null,
      isContractCheckOutDialog: false,
      isContractDialog: false,
      tempContract: null,
      headers: [
        {
          value: "contractId",
          text: this.$t('contract.contract_number_only'),
          width: "120px",
          align: "center"
        },
        {
          value: "businessName",
          text: this.$t('contract.business_name'),
          width: "200px"
        },
        {
          value: "customerFullName",
          text: this.$t('contract.contract_owner_name'),
          width: "200px"
        },
        {
          value: "areasText",
          text: this.$t('area.space'),
          width: "100px"
        },
        {
          value: "stallType",
          text: this.$t('area.stall_type'),
          align: "center"
        },
        {
          value: "paidStatus",
          text: this.$t('payment.title'),
          align: "center"
        },
        {
          value: "startDate",
          text: this.$t('contract.start_date'),
          align: "center"
        },
        {
          value: "endDate",
          text: this.$t('contract.end_date'),
          align: "center"
        },
        {
          value: "status",
          text: this.$t('status'),
          sortable: false,
          align: "center",
          width: "120px"
        },
        {
          width: "180px",
          text: "",
          align: "left",
          sortable: false,
          value: "actions"
        }
      ],
      items: [],
      selected: [],
      isLoading: false
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    marketName() {
      return this.$store.getters["markets/getMarketName"];
    },
    approveTasks() {
      return this.$store.getters["approveTask/getByType"]('renew_contract');
    },
    renewContractDataTable() {
      let data = []
      for(let approveTask of this.approveTasks) {
        let renewContract = approveTask.renewContract
        data.push({
          objectId: approveTask.objectId,
          approveTask: approveTask,
          renewContract: renewContract,
          contract: renewContract.contract,
          contractId: renewContract.contract.contractId,
          businessName: renewContract.contract.businessName,
          customerFullName: renewContract.contract.customerFullName,
          stallType: renewContract.contract.stallType,
          areasText: renewContract.contract.areasText,
          startDate: renewContract.startDate,
          endDate: renewContract.endDate,
          ageExpireStatus: renewContract.contract.ageExpireStatus,
          status: approveTask.status,
          statusColor: approveTask.statusColor,
          statusString: approveTask.statusString
        })
      }
      return data
    }
  },
  methods: {
    onPreApproveAll() {
      this.isConfirm = true;
    },
    onClickEdit(item) {
      this.approveTask = item.approveTask
      this.isApprove = true
      // this.isContractCheckOutDialog = true
    },
    
    onInit() {
      this.$emit("onInit");
    },
    afterUpdate(e) {
      this.isInterest = false;
      this.$emit("onInit", true);
      setTimeout(() => {
        this.isInterest = true;
      }, 500);
    },
    toggleSelectAll() {
      if (this.selected.length == this.approveTasks.length) {
        this.selected = [];
      } else {
        this.selected = this.approveTasks;
      }
    },
    editContractCheckOut(){
      this.isContractCheckOutDialog = true
    },
    async approveConfirm() {
      try {
        this.isLoading = true;
        // const approve = this.selected.map(async item => {
        //   await this.$store.dispatch("approveTask/approveApproveTask", {
        //     id: item.objectId
        //   });
        // });
        // await Promise.all(approve);
        for (const item of this.selected) {
          await this.$store.dispatch("approveTask/approveApproveTask", {
            id: item.objectId
          });
        }
        this.$toast.show({
          content: this.$t('task.approve_all_success'),
          color: "success"
        });
        this.isConfirm = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.isConfirm = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    async rejectConfirm({ note }) {
      try {
        this.isLoading = true;
        const approve = this.selected.map(async item => {
          await this.$store.dispatch("approveTask/rejectApproveTask", {
            id: item.objectId,
            cancelledNote: note
          });
        });
        await Promise.all(approve);
        this.$toast.show({
          content: this.$t('project.not_approve_appeal_list', { count: this.selected.length }),
          color: "success"
        });
        this.selected = [];
        this.isCancel = false;
        this.$emit("onInit", true);
        this.isLoading = false;
      } catch (e) {
        this.selected = [];
        this.isLoading = false;
        this.isCancel = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    },
    openContractDialog(contract) {
      this.tempContract = contract
      this.isContractDialog = true
    },
  }
};
</script>

<style>
</style>